// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B8luXJfi1X7_TV {
  color: var(--ds-text-danger, #ae2a19);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputErrors": `B8luXJfi1X7_TV`
};
export default ___CSS_LOADER_EXPORT___;
